/* Lazily upgrades the hero poster image to an interactive <model-viewer>.
   The model-viewer library is only fetched when the hero nears the viewport,
   so phones don't pay the GPU cost until the hero is about to be seen. */

class HeroModelViewer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          this.loadViewer();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(this);
  }

  async loadViewer() {
    if (!window.customElements.get('model-viewer')) {
      try {
        await import('https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js');
      } catch (e) {
        return; // keep the poster if the library fails to load
      }
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoRotate = this.dataset.autoRotate === 'true' && !prefersReducedMotion;

    const viewer = document.createElement('model-viewer');
    viewer.setAttribute('src', this.dataset.modelSrc);
    viewer.setAttribute('camera-controls', '');
    viewer.setAttribute('disable-zoom', '');
    viewer.setAttribute('interaction-prompt', 'none');
    viewer.setAttribute('shadow-intensity', '1');
    viewer.setAttribute('loading', 'lazy');
    viewer.setAttribute('alt', 'Interactive 3D logo');
    if (autoRotate) {
      viewer.setAttribute('auto-rotate', '');
      viewer.setAttribute('auto-rotate-delay', '0');
    }

    const poster = this.querySelector('.hero-3d__poster');
    if (poster) viewer.setAttribute('poster', poster.currentSrc || poster.src);

    viewer.addEventListener('load', () => this.classList.add('hero-3d__viewer--loaded'));
    this.appendChild(viewer);
  }
}

if (!window.customElements.get('hero-model-viewer')) {
  window.customElements.define('hero-model-viewer', HeroModelViewer);
}
